angular.module('omfm').directive('saoCompanyContacts', SaoCompanyContactsDirective);

SaoCompanyContactsDirective.$inject = ['$rootScope', 'SaoContact', 'Message', 'uiSimpleModal', 'SaoClient'];

function SaoCompanyContactsDirective($rootScope, SaoContact, Message, uiSimpleModal, SaoClient) {
	return {
		restrict:    "EA",
		replace:     true,
		scope:       {

		},
		templateUrl: "/app/omfm/templates/saoContacts.html",
		link:        function ($scope) {
			$scope.getList = function(){
				SaoContact.list({company_id: $scope.company.id}).$promise.then(function(data){
					$scope.contacts = data.contacts;
				}, function(){
					Message.pushError('Error on saving letters!', 1000);
				})
			};

			$scope.export = function (contact, $event) {
				$event.preventDefault();
				$event.stopPropagation();
				$event.stopImmediatePropagation();

				$rootScope.$broadcast('sao:export', {
					'type': 'contact',
					'callback': function(){
						SaoContact.export(contact, function(){
							Message.pushSuccess(`Contact ${contact.email} exported!`)
						});
					}
				});
			};

			$scope.editLetters = function(contact, $index){
				let save = function(letters, company, callback){
					SaoContact.save({
						id: contact.id, contact_id: contact.id, letters: letters
					}).$promise.then(function(){
						Message.pushSuccess('Letters saved!', 1000);

						if(typeof callback == "function"){
							callback()
						}
					}, function(){
						Message.pushError('Error on saving letters!', 1000);
					});
				};

				SaoContact.letters({
					contact_id: contact.id,
					list_id: $rootScope.selectedList.id
				}, function(cData){
					let data = {
						type: 'contact',
						contact: contact,
						title: 'Editing messages for contact ' + contact.mm_greeting,
						url: contact.url || $scope.company.url,
						letters: cData.letters,
						nextIndex: $index + 1,
						prevIndex: $index - 1,
						save: save
					};

					$scope.contacts = $scope.contacts.map(function(c){
						c.isActive = false;

						return c;
					});

					contact.isActive = true;

					$rootScope.$broadcast('sao:editLetters', data);
				});
			};

			$scope.rowClass = function(c){
				let cssClass = '';

				if(c.isActive){
					cssClass += ' table-primary';
				}

				if(c.edited || c.exported){
					cssClass += ' edited';
				}

				return cssClass;
			};

			$scope.addContact = function () {
				uiSimpleModal({
					title:       'Add new contact',
					templateUrl: '/app/omfm/templates/saoAddContactModal.html',
					size: '',
					showTitleClose: true,
					data: {},
					backdrop: 'static',
					returnData: true,
					buttons: ['ok', 'cancel']
				}).then(function(data){
					if(data.button !== 'ok'){
						return;
					}

					let newContactData = data.data;

					newContactData.list_id    = $scope.list.id;
					newContactData.company_id = $scope.company.id;

					SaoClient.importContact(newContactData, function(contact){
						Message.pushSuccess('Contact added!');
						$scope.contacts.push(contact);
					});

				}, function(){
					// Need to avoid errors in console
				});
			};

			$scope.setOrder = function (order) {
				if ($scope.order.field == order) {
					$scope.order.reverse = !$scope.order.reverse;
				} else {
					$scope.order.reverse = false;
				}

				$scope.order.field = order;
			};

			$scope.closeEditor = function(){
				$scope.letters = [];
				$scope.company = undefined;
				$scope.title   = '';
				$scope.search  = '';
				$scope.isOpen  = false;
				$rootScope.$broadcast('sao:closeLettersEditor', {type: 'contact'});
			};

			$scope.$on('sao:editLetters:byIndex', function(event, data){
				if(data.type !== 'company'){
					return;
				}

				let index = data.index;

				if(index < 0 || index > $scope.contacts.length){
					return;
				}

				let contact = $scope.contacts[data.index];

				if(!contact) {
					return;
				}

				$scope.editLetters(contact, index);
			});

			$scope.search = '';
			$scope.order = {
				field: '',
				reverse: false
			};

			$scope.$on('sao:openContacts', function(event, data){
				if(!data){
					return;
				}

				$scope.company = data.company;
				$scope.isOpen  = true;
				$scope.list    = data.list;
				$scope.getList();
			});

			$scope.$on('sao:closeContacts', function(){
				$rootScope.$broadcast('sao:closeLettersEditor', {type: 'contact'});
				$scope.closeEditor();
			});

			$scope.$on('sao:selectedList', function(event, list){
				$scope.selectedList = list;
			});

			$scope.$on('sao:lettersEditorClosed', function(event, data){
				if(data && data.type === 'company'){
					$scope.closeEditor();
				}
			})
		}
	}
}